import { useQuery } from 'react-query';
import { fetchSquadById } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';

export const useFetchSquadById = (squadId?: string) => {
  return useQuery(['fetchSquadById', squadId], () => fetchSquadById(squadId ?? ''), {
    enabled: !!squadId,
    // refetchOnWindowFocus: false,
  });
};
